import { SecureStoragePlugin } from 'capacitor-secure-storage-plugin'

export class VaultProxy {
	public static getItem = async (key: string): Promise<string | null> => {
		try {
			const item = await SecureStoragePlugin.get({ key })
			return item.value
		} catch (error: unknown) {
			console.error('Error getting item from vault:', error)
			return null
		}
	}

	public static setItem = async (key: string, value: string): Promise<boolean> => {
		try {
			await SecureStoragePlugin.set({ key, value })
			return true
		} catch (error: unknown) {
			console.error('Error setting item in vault:', error)
			return false
		}
	}

	public static removeItem = async (key: string): Promise<boolean> => {
		try {
			await SecureStoragePlugin.remove({ key })
			return true
		} catch (error: unknown) {
			console.error('Error removing item from vault:', error)
			return false
		}
	}
}
